<script>
// import Translations from "./insert-me-to-translate.vue";
import Recaptcha from './recaptcha';
import Hcaptcha from './hcaptcha';
import Turnstile from './turnstile';
import {mapGetters} from "vuex";
import {isValidEmail} from "../services/email_validator";

export default {
    data: function(){

        let data = this.getInitialData();
        data.loadRecaptchaComponent = false; // load once
        return data;
    },

    components: {
        Recaptcha,
        Hcaptcha,
        Turnstile,
        UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
    },

    computed: {
        ...mapGetters({
            isRecaptchaReady: 'ui/recaptcha/isReady',
            recaptchaResponse: 'ui/recaptcha/response',
        }),
    },

    methods: {
        getInitialData: function(){
            return {
                message:'',
                messageError:'',
                email:'',
                emailError:'',
                terms: false,
                termsError: false,
                sendDisabled: false,
                generalError: '',
                isRecaptchaFilled: true,
            };
        },

        resetForm: async function(event){
            let $form = $(this.$refs.message_form);
            let data = this.getInitialData();
            for(const prop in data){
                this.$data[prop] = data[prop];
            }

            await new Promise(resolve => setTimeout(resolve, 1000));
            this.$refs.recaptcha_reply.reset();
            $form.trigger('reset')
            $form.removeClass('d-none');
            $form.parent().find(".message-result").remove();
        },

        submit: async function(event){
            let form = event.target;
            let el = document.createElement('div');
            el.classList.add('message-result');

            this.sendDisabled = true;

            try{
                const response = await this.$http.post(form.action, $(form).serialize());
                el.innerHTML = response.data;
            }catch(error){
                let response = error.response;
                if(response.status == 400){
                    el.innerHTML = response.data;
                }else{
                    this.generalError = gettext('An unexpected error has occurred');
                }
            }finally{
                if(el.innerHTML){
                    $(form).addClass('d-none');
                    $(form).parent().append(el);
                }
                this.sendDisabled = false;
            }
        },

        validate: async function(event){

            this.termsError = '';
            this.messageError = '';
            this.emailError = '';
            this.generalError = '';
            this.isRecaptchaFilled = !!this.recaptchaResponse;
            if(
                this.isRecaptchaFilled
                && this.terms
                && isValidEmail(this.email.trim())
                && this.message.trim().length >= 4
            ){
                await this.submit(event);
            }else{
                if(!this.email.trim()){
                    this.emailError = gettext('Please fill in this field');
                }else if(!isValidEmail(this.email.trim())){
                    this.emailError = gettext('This is not a valid email');
                }
                if(this.message.trim().length < 4){
                    this.messageError = gettext('Message must contain at least 4 characters');
                }
                if(!this.terms){
                    this.termsError = gettext('You must accept Terms of use of the service and Privacy policies to continue.');
                }
                await this.$nextTick();
                this.$skokka.scrollToError();
            }
        }
    }
};
</script>
